import React from 'react';
import { User, Phone, Mail, MapPin } from 'lucide-react';
import { Client } from '../../types/client';
import { format, isValid, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

interface ClientCardProps {
  client: Client;
}

const formatClientDate = (dateValue: any): string => {
  if (!dateValue) return 'Date non disponible';

  try {
    const date = typeof dateValue === 'string' ? parseISO(dateValue) : new Date(dateValue);
    if (isValid(date)) {
      return format(date, 'dd MMMM yyyy', { locale: fr });
    }
  } catch (error) {
    console.error('Error formatting date:', error);
  }

  return 'Date invalide';
};

export const ClientCard: React.FC<ClientCardProps> = ({ client }) => {
  return (
    <div className="overflow-hidden rounded-lg bg-white shadow-sm ring-1 ring-gray-900/5 dark:bg-gray-800">
      <div className="p-6">
        <div className="flex items-center gap-4">
          <div className="h-12 w-12 rounded-full bg-primary-100 flex items-center justify-center dark:bg-primary-900">
            <User className="h-6 w-6 text-primary-600 dark:text-primary-300" />
          </div>
          <div>
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
              {client.civility} {client.firstName} {client.lastName}
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Dernier contact : {formatClientDate((client as any).last_contact || client.updatedAt)}
            </p>
          </div>
        </div>

        <div className="mt-4 space-y-2">
          <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
            <Phone className="h-4 w-4" />
            <span>{client.phone}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
            <Mail className="h-4 w-4" />
            <span>{client.email}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
            <MapPin className="h-4 w-4" />
            <span>{client.address}, {client.city}</span>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Commercial: {client.agent}
          </p>
        </div>
      </div>
    </div>
  );
};